<template>
<v-container fluid>
    <v-layout row wrap>
        <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap>
                <v-subheader class="headline black--text mt-2"> {{ this.$route.name  }}</v-subheader>
                <v-btn flat class="blue--text right" :to="`/catalog-lpu-add`">Добавить</v-btn>
              </v-layout>
            </v-flex>
        </v-layout >
        <v-navigation-drawer app right>
            <v-container>
                <v-layout row>
                    <v-flex xs12>
                        <div class="title mb-4">
                            Фильтры
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout column>
                    <v-flex xs12>
                        <v-select
                            label="Опубликовано"
                            v-model="filterIsActiveValue"
                            :items="commonFilterOptions"
                        ></v-select>
                    </v-flex>
                <v-flex xs12>
                    <v-select
                        label="Записывают"
                        v-model="filterIsAppointmentValue"
                        :items="commonFilterOptions"
                    ></v-select>
                </v-flex>
                <v-flex xs12>
                    <v-select
                        label="Есть в Нетрике"
                        v-model="filterIsNetrikaValue"
                        :items="commonFilterOptions"
                    ></v-select>
                </v-flex>
                <v-flex xs12>
                    <v-select
                        label="Есть в ОМС"
                        v-model="filterIsOMSValue"
                        :items="commonFilterOptions"
                    ></v-select>
                </v-flex>
                <v-flex xs12>
                    <v-select
                        label="Есть типы"
                        v-model="filterHasTypesValue"
                        :items="commonFilterOptions"
                    ></v-select>
                </v-flex>
                </v-layout>
                <v-layout>
                    <v-btn class="primary" @click.prevent="dropFilterOptions">Сбросить</v-btn>
                </v-layout>
            </v-container>
        </v-navigation-drawer>
        <v-layout row>
            <v-flex 6>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
            </v-flex>
            
        </v-layout >
    </v-layout>
    <v-data-iterator
        :items="filteredClinicList"
        content-tag="v-layout"
        loading
        :search="search"
        no-data-text="Массив клиник не загружен"
        no-results-text="Клиник соотвествующих фильтру не найдено"
        row
        :rows-per-page-items="rowsPerPage"
        rows-per-page-text="Элементов на странице"
        wrap
    >   

        <v-flex
            slot="item"
            slot-scope="props"
            xs12
        >
            <v-card elevation-1 class="mb-2">
                            <v-card-title style="padding: 8px 16px;">
                                <span class="subheading"><b>{{ props.item.name ? props.item.name : 'Не заполнено' }}</b></span>
                                    <v-tooltip bottom>
                                        <span slot="activator" style="margin-left: 10px;">
                                            <v-icon :class="props.item.isActive ? ['green--text'] : ['red--text']" size="x-large">remove_red_eye</v-icon>
                                        </span>
                                        <span>{{ (props.item.isActive) ? 'Опубликовано на сайте' : 'Не опубликовано' }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <span slot="activator" style="margin-left: 10px;" v-if="!props.item.isAppointment">
                                            <v-icon class="red--text" size="medium">block</v-icon>
                                        </span>
                                        <span>Не записывают</span>
                                    </v-tooltip>
                            </v-card-title>
                <v-card-text style="padding: 0 16px 10px 16px">
                    <v-layout wrap>
                        <v-flex xs7>                        
                            <div class="caption">ТИП: <b>{{ props.item.clinicTypes.length === 0 ? 'Не заполнено' :  props.item.clinicTypes.join('; ') }}</b></div>
                            <div class="caption">НЕТРИКА: <b>{{ props.item.netrika.fullNames.length === 0 ? 'Не заполнено' :  props.item.netrika.fullNames.join('; ') }}</b></div>
                            <div class="caption">ОМС: <b>{{ props.item.oms.name ? props.item.oms.name : 'Не заполнено' }}</b></div>
                        </v-flex>
                        <v-flex xs5>
                            <v-layout wrap>
                                <v-flex xs6>
                                    <div class="caption">Регион: <b>{{ props.item.region.name ? props.item.region.name : 'Не указан' }}</b></div>
                                    <div class="caption">Район: <b>{{ (props.item.district) ? props.item.district : 'Не указан'}}</b></div>
                                    <div class="caption">ID Netrika: <b>{{ (props.item.netrika.id) ? props.item.netrika.id : 'Не указан' }}</b></div>
                                    <div class="caption">ID ОМС: <b>{{ (props.item.oms.id) ? props.item.oms.id : 'Не указан' }}</b></div>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-flex xs6>
                                    <v-btn flat class="blue--text right" :to="`/catalog-lpu/${props.item.id}`"><v-icon left>edit</v-icon> Редактировать</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                
                
                    
                    <v-layout column>
                        
                        <v-layout row justify-space-between>
                            <v-flex xs-2>
                                
                            </v-flex>
                            <v-flex xs-2>
                            </v-flex>
                            <v-flex xs-2 offset1>
                                
                            </v-flex>
                            <v-flex xs-2 offset1>
                                
                            </v-flex>
                        </v-layout>
                    </v-layout>
                    <v-spacer></v-spacer>
                    
                
            </v-card>
        </v-flex>
    </v-data-iterator>
</v-container>
</template>

<script>
import { API } from '@/utils'
import AllClinic from '@/components/spravochnik/AllClinic'

export default {
    data() {
        return {
            rowsPerPage: [50, 100, 150, 200, { text :"Всё", value: -1 }],
            
            

            commonFilterOptions: [
                { text: "Не указано", value: null },
                { text: "Да", value: true },
                { text: "Нет", value: false }
            ]
        }
    },
    computed: {
        clinicsList() {
            return this.$store.getters.GET_CLINICS
        },

        search: {
            get: function() {
                return this.$store.getters.GET_FILTER_STATE.search
            },
            set: function(v) {
                this.$store.dispatch('SET_FILTER_OPTIONS', { search: v})
            }
        },

        filterIsActiveValue: {
            get: function () {
                return this.$store.getters.GET_FILTER_STATE.isActive
            },
            set: function (v) {
                this.$store.dispatch('SET_FILTER_OPTIONS', {isActive: v})
            }
        },
        
        filterIsAppointmentValue: {
            get: function () {
                return this.$store.getters.GET_FILTER_STATE.isAppointment
            },
            set: function (v) {                
                this.$store.dispatch('SET_FILTER_OPTIONS', {isAppointment: v})
            }
        },
        
        filterIsNetrikaValue: {
            get: function () {
                return this.$store.getters.GET_FILTER_STATE.isNetrikaId
            },
            set: function (v) {
                this.$store.dispatch('SET_FILTER_OPTIONS', {isNetrikaId: v})
            }
        },

        filterIsOMSValue: {            
            get: function () {
                return this.$store.getters.GET_FILTER_STATE.isOmsId
            },
            set: function (v) {
                this.$store.dispatch('SET_FILTER_OPTIONS', {isOmsId: v})
            }
        },

        filterHasTypesValue: {            
            get: function () {
                return this.$store.getters.GET_FILTER_STATE.hasTypes
            },
            set: function (v) {
                this.$store.dispatch('SET_FILTER_OPTIONS', {hasTypes: v})
            }
        },

        filteredClinicList() {
            return this.clinicsList.filter(item => (this.filterIsActiveValue !== null)
                    ? item.isActive === this.filterIsActiveValue
                    : item
            )
            .filter(item => {
                return this.filterIsAppointmentValue !== null
                    ? item.isAppointment === this.filterIsAppointmentValue
                    : item
            })
            .filter(item => {
                return this.filterIsNetrikaValue !== null
                    ? !!item.netrika.id === this.filterIsNetrikaValue
                    : item
            })
            .filter(item => {
                return this.filterIsOMSValue !== null
                    ? !!item.oms.id === this.filterIsOMSValue
                    : item
            })
            .filter(item => {             
                return this.filterHasTypesValue !== null
                    ? !!item.clinicTypes.length === this.filterHasTypesValue
                    : item
            })
        }
    },
    methods: {
        dropFilterOptions() {
            this.$store.dispatch('DROP_FILTER_OPTIONS')
        }
    },
    created() {        
        this.$store.dispatch('LOAD_ALL_CLINICS')
    },
    components: {
        AllClinic
    }
}
</script>
